import mod from '@/js/modernisierung';
import { kasseClient } from '@/js/helpers/backend-clients';
import { defaultState } from './state';
import UploadFile from '@/js/uploadFile';
import { displayAxiosError } from '@/js/helpers/utils';

export default {
  SET_ONCE_OBJEKTART(state, objektart) {
    if (state.allgemeineAngaben.objektart === undefined) {
      state.allgemeineAngaben.objektart = objektart;
    }
  },
  SET_ERMITTLUNGSSTICHTAG(state, ermittlungsstichtag) {
    state.allgemeineAngaben.ermittlungsstichtag = ermittlungsstichtag;
  },
  SET_BAUJAHR(state, baujahr) {
    state.allgemeineAngaben.baujahr = baujahr;
  },
  SET_WOHNUNGSNUMMER(state, wohnungsnummer) {
    state.allgemeineAngaben.wohnungsnummer = wohnungsnummer;
  },
  SET_ANZAHL_WOHNEINHEITEN(state, anzahlWohneinheiten) {
    const number = parseInt(anzahlWohneinheiten);
    state.allgemeineAngaben.anzahlWohneinheiten = isNaN(number) ? undefined : number;
  },
  SET_ANZAHL_NUTZEINHEITEN(state, anzahlNutzeinheiten) {
    const number = parseInt(anzahlNutzeinheiten);
    state.allgemeineAngaben.anzahlNutzeinheiten = isNaN(number) ? undefined : number;
  },
  SET_WOHNFLAECHE(state, wohnflaeche) {
    const number = parseFloat(wohnflaeche);
    state.allgemeineAngaben.wohnflaeche = isNaN(number) ? undefined : number;
  },
  SET_NUTZFLAECHE(state, nutzflaeche) {
    const number = parseFloat(nutzflaeche);
    state.allgemeineAngaben.nutzflaeche = isNaN(number) ? undefined : number;
  },
  SET_KERNSANIERUNG(state, kernsanierung) {
    state.allgemeineAngaben.kernsanierung = kernsanierung;
    if (!kernsanierung) {
      state.allgemeineAngaben.jahrDerKernsanierung = undefined;
    }
  },
  SET_JAHR_DER_KERNSANIERUNG(state, jahrDerKernsanierung) {
    state.allgemeineAngaben.jahrDerKernsanierung = jahrDerKernsanierung;
  },

  SET_AUSSENWAENDE_MODERNISIERUNG(state, modernisierung) {
    state.aussenwaende.modernisierung = modernisierung;
    if (modernisierung === mod.KEINE.value) {
      state.aussenwaende.jahrDerModernisierung = undefined;
    }
  },
  SET_AUSSENWAENDE_JAHR_DER_MODERNISIERUNG(state, jahrDerModernisierung) {
    state.aussenwaende.jahrDerModernisierung = jahrDerModernisierung;
  },

  SET_DACH_MODERNISIERUNG(state, modernisierung) {
    state.dach.modernisierung = modernisierung;
    if (modernisierung === mod.KEINE.value) {
      state.dach.jahrDerModernisierung = undefined;
    }
  },
  SET_DACH_JAHR_DER_MODERNISIERUNG(state, jahrDerModernisierung) {
    state.dach.jahrDerModernisierung = jahrDerModernisierung;
  },

  SET_FENSTER_MODERNISIERUNG(state, modernisierung) {
    state.fenster.modernisierung = modernisierung;
    if (modernisierung === mod.KEINE.value) {
      state.fenster.jahrDerModernisierung = undefined;
    }
  },
  SET_FENSTER_JAHR_DER_MODERNISIERUNG(state, jahrDerModernisierung) {
    state.fenster.jahrDerModernisierung = jahrDerModernisierung;
  },

  SET_FUSSBOEDEN_MODERNISIERUNG(state, modernisierung) {
    state.fussboeden.modernisierung = modernisierung;
    if (modernisierung === mod.KEINE.value) {
      state.fussboeden.jahrDerModernisierung = undefined;
    }
  },
  SET_FUSSBOEDEN_JAHR_DER_MODERNISIERUNG(state, jahrDerModernisierung) {
    state.fussboeden.jahrDerModernisierung = jahrDerModernisierung;
  },

  SET_INNENWAENDE_MODERNISIERUNG(state, modernisierung) {
    state.innenwaende.modernisierung = modernisierung;
    if (modernisierung === mod.KEINE.value) {
      state.innenwaende.jahrDerModernisierung = undefined;
    }
  },
  SET_INNENWAENDE_JAHR_DER_MODERNISIERUNG(state, jahrDerModernisierung) {
    state.innenwaende.jahrDerModernisierung = jahrDerModernisierung;
  },

  SET_DECKEN_MODERNISIERUNG(state, modernisierung) {
    state.decken.modernisierung = modernisierung;
    if (modernisierung === mod.KEINE.value) {
      state.decken.jahrDerModernisierung = undefined;
    }
  },
  SET_DECKEN_JAHR_DER_MODERNISIERUNG(state, jahrDerModernisierung) {
    state.decken.jahrDerModernisierung = jahrDerModernisierung;
  },

  SET_SANITAER_MODERNISIERUNG(state, modernisierung) {
    state.sanitaer.modernisierung = modernisierung;
    if (modernisierung === mod.KEINE.value) {
      state.sanitaer.jahrDerModernisierung = undefined;
    }
  },
  SET_SANITAER_JAHR_DER_MODERNISIERUNG(state, jahrDerModernisierung) {
    state.sanitaer.jahrDerModernisierung = jahrDerModernisierung;
  },

  SET_HEIZUNG_MODERNISIERUNG(state, modernisierung) {
    state.heizung.modernisierung = modernisierung;
    if (modernisierung === mod.KEINE.value) {
      state.heizung.jahrDerModernisierung = undefined;
    }
  },
  SET_HEIZUNG_JAHR_DER_MODERNISIERUNG(state, jahrDerModernisierung) {
    state.heizung.jahrDerModernisierung = jahrDerModernisierung;
  },

  SET_TECHNISCHE_AUSSTATTUNG_MODERNISIERUNG(state, modernisierung) {
    state.technischeAusstattung.modernisierung = modernisierung;
    if (modernisierung === mod.KEINE.value) {
      state.technischeAusstattung.jahrDerModernisierung = undefined;
    }
  },
  SET_TECHNISCHE_AUSSTATTUNG_JAHR_DER_MODERNISIERUNG(state, jahrDerModernisierung) {
    state.technischeAusstattung.jahrDerModernisierung = jahrDerModernisierung;
  },

  SET_OBJEKTUNTERLAGEN_GRUNDRISS(state, grundriss) {
    state.objektunterlagen.grundriss = UploadFile.instanceOf(grundriss);
    kasseClient
      .uploadOrDelete(grundriss, 'ndgmfh', '_grundriss_unterlagen', 0)
      .then(() => state.objektunterlagen.grundriss?.done())
      .catch(error => {
        displayAxiosError(error);
        state.objektunterlagen.grundriss = undefined;
      });
  },
  SET_OBJEKTUNTERLAGEN_ZUSATZDOKUMENT_GRUNDRISS(state, zusatzdokumentGrundriss) {
    state.objektunterlagen.zusatzdokumentGrundriss = UploadFile.instanceOf(zusatzdokumentGrundriss);
    kasseClient
      .uploadOrDelete(zusatzdokumentGrundriss, 'ndgmfh', '_grundriss_zusatz_unterlagen', 0)
      .then(() => state.objektunterlagen.zusatzdokumentGrundriss?.done())
      .catch(error => {
        displayAxiosError(error);
        state.objektunterlagen.zusatzdokumentGrundriss = undefined;
      });
  },
  SET_OBJEKTUNTERLAGEN_ENERGIEAUSWEIS(state, energieausweis) {
    state.objektunterlagen.energieausweis = UploadFile.instanceOf(energieausweis);
    kasseClient
      .uploadOrDelete(energieausweis, 'ndgmfh', '_grundriss_energieausweis', 0)
      .then(() => state.objektunterlagen.energieausweis?.done())
      .catch(error => {
        displayAxiosError(error);
        state.objektunterlagen.energieausweis = undefined;
      });
  },
  SET_OBJEKTUNTERLAGEN_ZUSATZDOKUMENT_ENERGIEAUSWEIS(state, zusatzdokumentEnergieausweis) {
    state.objektunterlagen.zusatzdokumentEnergieausweis = UploadFile.instanceOf(
      zusatzdokumentEnergieausweis,
    );
    kasseClient
      .uploadOrDelete(zusatzdokumentEnergieausweis, 'ndgmfh', '_grundriss_zusatz_energieausweis', 0)
      .then(() => state.objektunterlagen.zusatzdokumentEnergieausweis?.done())
      .catch(error => {
        displayAxiosError(error);
        state.objektunterlagen.zusatzdokumentEnergieausweis = undefined;
      });
  },

  SET_ANSPRECHPARTNER_NACHNAME(state, nachname) {
    window.sessionStorage.setItem('nname', nachname);
    state.ansprechpartner.nachname = nachname;
  },
  SET_ANSPRECHPARTNER_VORNAME(state, vorname) {
    window.sessionStorage.setItem('vname', vorname);
    state.ansprechpartner.vorname = vorname;
  },
  SET_ANSPRECHPARTNER_TELEFON(state, telefon) {
    state.ansprechpartner.telefon = telefon;
  },
  SET_ANSPRECHPARTNER_ERLAEUTERUNG(state, erlaeuterung) {
    state.ansprechpartner.erlaeuterung = erlaeuterung;
  },
  SET_ALTERNATE_ANSPRECHPARTNER_NAME(state, alternateName) {
    state.ansprechpartner.altName = alternateName;
  },
  SET_ALTERNATE_ANSPRECHPARTNER_FUNCTION(state, alternateFunction) {
    state.ansprechpartner.altFunktion = alternateFunction;
  },
  SET_ALTERNATE_ANSPRECHPARTNER_TELEFON(state, alternateTelefon) {
    state.ansprechpartner.altTelefon = alternateTelefon;
  },
  SET_ALTERNATE_ANSPRECHPARTNER_EMAIL(state, alternateEmail) {
    state.ansprechpartner.altEmail = alternateEmail;
  },

  SET_DEFAULT_RECHNUNG_NAME1(state, name1) {
    state.defaultRechnung.name1 = name1;
  },
  SET_DEFAULT_RECHNUNG_NAME2(state, name2) {
    state.defaultRechnung.name2 = name2;
  },
  SET_DEFAULT_RECHNUNG_PLZ(state, plz) {
    state.defaultRechnung.plz = plz;
  },
  SET_DEFAULT_RECHNUNG_ORT(state, ort) {
    state.defaultRechnung.ort = ort;
  },
  SET_DEFAULT_RECHNUNG_STR(state, str) {
    state.defaultRechnung.str = str;
  },
  SET_DEFAULT_RECHNUNG_HNR(state, hnr) {
    state.defaultRechnung.hnr = hnr;
  },

  SET_ALTERNATIVE_RECHNUNG_NAME1(state, name1) {
    state.alternativeRechnung.name1 = name1;
  },
  SET_ALTERNATIVE_RECHNUNG_NAME2(state, name2) {
    state.alternativeRechnung.name2 = name2;
  },
  SET_ALTERNATIVE_RECHNUNG_PLZ(state, plz) {
    state.alternativeRechnung.plz = plz;
  },
  SET_ALTERNATIVE_RECHNUNG_ORT(state, ort) {
    state.alternativeRechnung.ort = ort;
  },
  SET_ALTERNATIVE_RECHNUNG_STR(state, str) {
    state.alternativeRechnung.str = str;
  },
  SET_ALTERNATIVE_RECHNUNG_HNR(state, hnr) {
    state.alternativeRechnung.hnr = hnr;
  },
  SET_USE_DEFAULT_RECHNUNG_DATA(state, useDefault) {
    state.alternativeRechnung.useDefault = useDefault;
  },

  RESET_STATE(state) {
    window.sessionStorage.removeItem('vname');
    window.sessionStorage.removeItem('nname');
    Object.assign(state, defaultState());
  },
};
